export default __webpack_public_path__ + "static/web3_game_banner-bd73b6cd49a9bdf0e083773ff67a1ffe.webp";